export const GET_PROFILE = 'user-reducer|GET_PROFILE';
export const FETCH_CONTRACT = "app-reducer|FETCH_CONTRACT"